import { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ChakraProvider, extendTheme } from "@chakra-ui/react";
import { Amplify, Hub } from "aws-amplify";
import { Toaster } from "react-hot-toast";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { ThemeProvider } from "styled-components";
import AppRoutes from "./AppRoutes";
import { GlobalStyles } from "./Assets/Styles/GlobalStyles";
import awsconfig from "./aws-exports";
import ErrorBoundary from "./Reusable/ErrorBoundary/ErrorBoundary";
import { vars } from "./Theme.css";
import AuthRoutes from "./AuthRoutes";
import { CookiesProvider } from "react-cookie";
import AppAccessForm from "./Components/AppAccessForm";
import {  useSelector } from "react-redux";
import useSignout from "./hooks/useSignout";
import { customConsole } from "./utils/helper";
import { useLazyGetProfileQuery } from "../redux/reducers/apiSlice";

// >>New - Configuring Auth Module
Amplify.configure(awsconfig);

function App() {

  const token = useSelector((state: { auth: { token: string; } }) => state.auth.token)
  const { signOut } = useSignout();
  const [getProfile, { data: profileData, isLoading: profileDataIsLoading, error: profileDataError }] = useLazyGetProfileQuery();
  const isAuthenticated = !!token && profileData?.id;

  const chakraTheme = extendTheme({
    fonts: { ...vars.fonts },
    colors: {
      primary: {
        50: "#f9c7b7",
        100: "#f7b19a",
        200: "#f59c7e",
        300: "#f38662",
        400: "#f07045",
        500: vars.color.primary,
        600: "#e64712",
        700: "#ca3e10",
        800: "#ad350e",
        900: "#912d0c",
      },
    },
    sizes: { ...vars.sizes },
    breakpoints: { ...vars.breakpoints },
    styles: {
      global: {
        a: {
          color: vars.color.primary,
        },
      },
    },
  });

  useEffect(() => {
    if(token){
      getProfile();
    }
  },[token])

  const handleUserEvent = async (data) => {
    customConsole("log","Hub Data", data);
    customConsole("log","⚠️ Hub Event:", data?.payload.event);

    if(data?.payload){
      switch (data?.payload.event) {
        case "signIn":
          customConsole("log","⚠️ User signed in");
          break;
        case "signOut":
          customConsole("log","⚠️ Hub Event Signin: User signed out");
          break;
        case "tokenRefresh":
          customConsole("log","⚠️ Hub Event Token refresh: Token was successfully refreshed");
          break;
        case "tokenRefresh_failure":
          customConsole("log","⚠️ Hub Event Session expired or refresh token failed");
          signOut(); // or use your router
          break;
        default:
          break;
      }
    }
  
  };

  useEffect(() => {
    Hub.listen("auth", handleUserEvent);
  }, []);


  if (
    window.localStorage.getItem("app_access") !== "true" &&
    // @ts-ignore
    import.meta.env.MODE === "staging"
  ) {
    return <AppAccessForm />;
  }

  return (
    <ChakraProvider theme={chakraTheme}>
      <CookiesProvider>
        {/* @ts-ignore */}
        <ThemeProvider theme={vars}>
          {/* @ts-ignore */}
          <GlobalStyles />
          <Router>
            <ErrorBoundary>
              {isAuthenticated ? (
                <AppRoutes  />
              ) : (
                <AuthRoutes  />
              )}
            </ErrorBoundary>
          </Router>
        </ThemeProvider>
        <Toaster />
      </CookiesProvider>
    </ChakraProvider>
  );
}

export default App;
